<script>
/**
 * ****************************************************************************
 * @description     :   Main component for MNG_DM_Message
 * @created at      :   2025/10/27
 * @created by      :   quanlh
 * @package         :   Move
 * @copyright       :   Copyright (c) A.N.S Asia
 * @version         :   1.0.0
 * ****************************************************************************
 */

/**
 * Import libraries
 */
import './style.scss';
import { nextTick } from 'vue';
import messages, { MSG_BUTTON, MSG_TITLE, MSG_TYPE } from '@/utils/messages';
import { mapActions, mapMutations, mapState } from 'vuex';
import { useWindowSize } from '@/utils/composables/useWindowSize.js';

import store from '@/store';
import MNG_DM_Message_Store from '@/views/popupSearch/popup_MNG_DM_Message/store';
import PopupMST001 from '@/views/popupSearch/PopupMST001/store';
import PopupMST005 from '@/views/popupSearch/PopupMST005/store';
import PopupMST008 from '@/views/popupSearch/PopupMST008/store';
import PopupMST002 from '@/views/popupSearch/PopupMST002/store';
import PopupMST003 from '@/views/popupSearch/PopupMST003/store';

import template from './template.html';
import MessageList from './childComponent/MessageList.vue';
import MessageHeaderSection from './childComponent/MessageHeaderSection.vue';
import MessageListSection from './childComponent/MessageListSection.vue';
import GroupManagementSection from './childComponent/GroupManagementSection.vue';
import FolderManagementSection from './childComponent/FolderManagementSection.vue';
import MessageComposeSection from './childComponent/MessageComposeSection.vue';

var MNG_DM_Message = {
    name: 'MNG_DM_Message',
    setup() {
        const { windowWidth } = useWindowSize();
        return {
            windowWidth
        };
    },
    template: template,
    components: {
        MessageList,
        MessageHeaderSection,
        MessageListSection,
        GroupManagementSection,
        FolderManagementSection,
        MessageComposeSection
    },
    beforeCreate() {
        if (!store.hasModule('MNG_DM_Message_Store')) {
            store.registerModule('MNG_DM_Message_Store', MNG_DM_Message_Store);
        }
        if (!store.hasModule('PopupMST001')) {
            store.registerModule('PopupMST001', PopupMST001);
        }
        if (!store.hasModule('PopupMST002')) {
            store.registerModule('PopupMST002', PopupMST002);
        }
        if (!store.hasModule('PopupMST003')) {
            store.registerModule('PopupMST003', PopupMST003);
        }
        if (!store.hasModule('PopupMST005')) {
            store.registerModule('PopupMST005', PopupMST005);
        }
        if (!store.hasModule('PopupMST008')) {
            store.registerModule('PopupMST008', PopupMST008);
        }
    },
    created() {
        this.searchMessages(1);
        this.initData();
    },
    mounted() {
        nextTick(() => {
            const input = document.getElementById('department_id');
            if (input) input.focus();
        });
    },
    unmounted() {},
    data() {
        return {
            screenId: 'MNG_DM_Message',
            tab: 'all',
            listSpanMember: [],
            errors: []
        };
    },
    watch: {
        dmMessageMode(val) {
            this.tab = val == 'compose' ? 'internal' : 'all';
            if (val == 'receive' || val == 'send') {
                this.searchMessages(val == 'receive' ? 1 : 2);
                this.data.isFolderManagement = false;
                this.data.internal.isReply = false;
            }
            if (val == 'receive' || val == 'send' || val == 'compose' || (val == 'group' && !this.data.isFolderManagement)) {
                this.initData();
                this.listSpanMember = [];
            }
            if (val == 'receive' || val == 'send' || (val == 'group' && this.data.isFolderManagement)) {
                this.searchFolder();
            }
            if (val == 'group' && this.data.isFolderManagement) {
                this.updatePopupConfig({ title: 'フォルダー一覧' });
            }
        },
        tab(newTab) {
            if (this.dmMessageMode == 'compose' && !this.data.internal.isReply) {
                this.resetDataInit();
            }
            this.rerenderFolder(newTab);
        }
    },
    computed: {
        ...mapState('app', ['user', 'isShowLeftMenu', 'dmMessageMode']),
        ...mapState('MNG_DM_Message_Store', ['data', 'options']),
        visibleTabs() {
            const tabs = [
                { key: 'all', label: '全て', show: this.isListMode },
                { key: 'internal', label: '社内', show: true },
                { key: 'external', label: '社外', show: true },
                { key: 'group', label: 'グループ', show: true },
                { key: 'comment', label: '日報 ', show: this.isListMode },
                { key: 'system', label: 'システム', show: this.dmMessageMode === 'receive' }
            ];
            return tabs.filter((t) => t.show);
        },

        isListMode() {
            return this.dmMessageMode === 'receive' || this.dmMessageMode === 'send';
        },

        tabComponents() {
            return {
                all: 'MessageList',
                internal: 'MessageList',
                external: 'MessageList',
                system: 'MessageList',
                comment: 'MessageList'
            };
        },

        messages() {
            const source = this.dmMessageMode === 'receive' ? this.data.messages : this.data.inbox;

            const base = {
                internal: source.filter((m) => m.MessageType == 1 || m.MessageType == 3),
                external: source.filter((m) => m.MessageType == 2),
                comment: source.filter((m) => m.MessageType == 4),
                group: source.filter((m) => m.MessageType == 3)
            };

            return {
                all: [...source],
                ...base,
                system: source.filter((m) => m.MessageType == 5)
            };
        },

        isManagementMode() {
            return this.dmMessageMode === 'group' || this.dmMessageMode === 'groupDetail';
        },
        isGroupManagement() {
            return this.isManagementMode && !this.data.isFolderManagement;
        },
        filterFolderMessage() {
            const box = this.dmMessageMode == 'receive' ? 0 : 1;
            const type = this.tab == 'internal' ? 0 : 1;
            return this.data.listFolder.filter((f) => f.BoxType == box && f.MessageType == type);
        }
    },
    methods: {
        ...mapMutations('app', ['setScreenId', 'setHeader', 'showModalMessage', 'hideModalMessage', 'setDmMessageMode', 'updatePopupConfig']),
        ...mapMutations('MNG_DM_Message_Store', [
            'resetDataInit',
            'setListGroup',
            'setGroupManagement',
            'setGroupDetail',
            'setFolder',
            'setFolderCount',
            'setFolderDetail'
        ]),
        ...mapActions('MNG_DM_Message_Store', [
            'listDM',
            'getGroup',
            'getFolder',
            'getFolderCount',
            'storeMessage',
            'storeGroup',
            'deleteGroup',
            'storeFolder',
            'deleteFolder'
        ]),
        ...mapActions('PopupMST001', ['searchMst001Info']),
        ...mapActions('PopupMST002', ['searchMst002Info']),
        ...mapActions('PopupMST003', ['searchMst003Info']),
        ...mapActions('PopupMST005', ['searchAreaInfo']),
        ...mapActions('PopupMST008', ['searchMst008Info']),
        initData() {
            this.getGroup({
                params: {
                    CompanyCD: this.user.company_cd,
                    UserID: this.user.EmployeeCD,
                    Mode: 1,
                    Keyword: '',
                    GroupID: ''
                },
                callback: (data) => {
                    this.setListGroup(data);
                    this.setGroupManagement(data);
                }
            });
        },
        rerenderFolder(newTab) {
            const isTargetMode = this.dmMessageMode === 'receive' || this.dmMessageMode === 'send';
            const isTargetTab = newTab === 'internal' || newTab === 'external';

            if (!isTargetMode || !isTargetTab) return;

            const box = this.dmMessageMode === 'receive' ? 0 : 1;
            const type = newTab === 'internal' ? 0 : 1;

            this.getFolderCount({
                params: {
                    CompanyCD: this.user.company_cd,
                    UserID: this.user.EmployeeCD,
                    BoxType: box,
                    MessageType: type
                },
                callback: (data) => {
                    this.setFolderCount(data);
                }
            });
        },
        activeTab(tabName) {
            this.tab = tabName;
        },
        clearInboxSearch() {
            this.data.Keyword = '';
            this.data.TargetDate = '';
            this.searchMessages(this.dmMessageMode == 'receive' ? 1 : 2);
        },
        searchMessages(mode) {
            this.listDM({
                params: {
                    CompanyCD: this.user.company_cd,
                    UserID: this.user.EmployeeCD,
                    Mode: mode,
                    Keyword: this.data.Keyword,
                    TargetDate: this.data.TargetDate
                }
            });
        },
        referMDCD(index, value, item) {
            if (value) {
                this.searchAreaInfo({
                    company_cd: this.user?.company_cd ?? 0,
                    department_cd: value,
                    mode: 1,
                    callback: (response) => {
                        if (response.Data.data.length > 0) {
                            const result = response.Data.data[0];
                            item.MDCD = result.department_cd;
                            item.MDName = result.department_name;
                        } else {
                            item.MDCD = '';
                            item.MDName = '';
                        }
                    },
                    onError: (error) => {
                        console.log(error);
                    }
                });
            } else {
                item.MDCD = '';
                item.MDName = '';
            }
        },
        getMDName(data, item) {
            item.MDName = data;
        },
        referEmployee(index, value, item) {
            const destination = item ? item : this.data.internal;
            if (value) {
                this.searchMst008Info({
                    company_cd: this.user.company_cd,
                    employee_cd: value,
                    mode: 1,
                    callback: (response) => {
                        if (response.Data.data.length > 0) {
                            const result = response.Data.data[0];
                            destination.EmployeeCD = result.user_cd;
                            destination.EmployeeName = result.user_name;
                        } else {
                            destination.EmployeeCD = '';
                            destination.EmployeeName = '';
                        }
                    },
                    onError: (error) => {
                        console.log(error);
                    }
                });
            } else {
                destination.EmployeeCD = '';
                destination.EmployeeName = '';
            }
        },
        getEmployeeName(data, item) {
            const destination = item ? item : this.data.internal;
            destination.EmployeeName = data;
        },
        referClientInfo(index, value, item) {
            const destination = item ? item : this.data.external;
            if (!value) return;
            this.searchMst001Info({
                company_cd: this.user.company_cd ?? '',
                customer_cd: value || 0,
                mode: 1,
                pageNo: 1,
                pageSize: 1,
                callback: (response) => {
                    const result = response?.Data?.data?.[0];
                    if (result) {
                        destination.ClientCD = result.customer_cd;
                        destination.ClientName = result.customer_name;
                    } else {
                        destination.ClientCD = '';
                        destination.ClientName = '';
                    }
                }
            });
        },
        getClientName(data, item) {
            const destination = item ? item : this.data.external;
            destination.ClientName = data;
        },
        getBranchName(data, item) {
            const destination = item ? item : this.data.external;
            destination.BranchName = data;
        },
        referBranchCD(index, value, item) {
            const destination = item ? item : this.data.external;
            if (!value) {
                destination.BranchCD = '';
                destination.BranchName = '';
                return;
            }
            this.searchMst002Info({
                company_cd: this.user?.company_cd ?? '',
                mdcd: destination.MDCD ?? 0,
                customer_cd: destination.ClientCD ?? 0,
                location_cd: value || 0,
                pageNo: 1,
                pageSize: 1,
                mode: 1,
                callback: (response) => {
                    const result = response?.Data?.data?.[0];
                    if (result) {
                        destination.BranchCD = result.location_cd;
                        destination.BranchName = result.location_name;
                    } else {
                        destination.BranchCD = '';
                        destination.BranchName = '';
                    }
                }
            });
        },
        getUserName(data, item) {
            const destination = item ? item : this.data.external;
            destination.UserName = data;
        },
        referUser(index, value, item) {
            const destination = item ? item : this.data.external;
            if (!value) {
                destination.UserID = '';
                destination.UserName = '';
                return;
            }
            this.searchMst003Info({
                company_cd: this.data.CompanyCD ?? '',
                customer_cd: destination.ClientCD ?? '',
                location_cd: destination.BranchCD ?? '',
                person_id: value,
                pageNo: 1,
                pageSize: 1,
                mode: 1,
                callback: (response) => {
                    const result = response?.Data?.data?.[0];
                    if (result) {
                        destination.UserID = result.person_id;
                        destination.UserName = result.person_name;
                    } else {
                        destination.UserID = '';
                        destination.UserName = '';
                    }
                }
            });
        },
        clearForm() {
            this.updatePopupConfig({ title: 'DM送信一覧' });
            this.setDmMessageMode('send');
            this.resetDataInit();
        },
        submitForm() {
            this.showModalMessage({
                type: MSG_TYPE.CONFIRM,
                title: MSG_TITLE.C002,
                content: '送信してもよろしいですか？',
                cancelText: MSG_BUTTON.cancelText,
                okText: MSG_BUTTON.okText,
                callback: () => {
                    const formData = new FormData();
                    const map = {
                        internal: 1,
                        external: 2,
                        group: 3
                    };
                    if (this.tab == 'group') {
                        this.data.group.MDCD = this.user.MDCD ?? 0;
                    }
                    const payload = { ...this.data[this.tab], MessageType: map[this.tab], CompanyCD: this.user.company_cd };

                    formData.append('json', JSON.stringify(payload));

                    this.storeMessage({
                        params: formData,
                        callback: () => {
                            this.showModalMessage({
                                type: MSG_TYPE.SUCCESS,
                                title: '報告',
                                content: '送信しました。',
                                okText: 'OK'
                            });
                            this.clearForm();
                        }
                    });
                }
            });
        },
        filterGroupMessage() {
            const source = this.dmMessageMode === 'receive' ? this.data.messages : this.data.inbox;

            const isAll = this.data.GroupID == 9999999;

            this.messages.group = source.filter((m) => m.IsGroup == 1 && (isAll || m.GroupID == this.data.GroupID));
        },
        searchGroup() {
            this.getGroup({
                params: {
                    CompanyCD: this.user.company_cd,
                    UserID: this.user.EmployeeCD,
                    Mode: 1,
                    Keyword: this.data.groupKeyWord,
                    GroupID: ''
                },
                callback: (data) => {
                    this.setGroupManagement(data);
                }
            });
        },
        searchFolder() {
            this.getFolder({
                params: {
                    CompanyCD: this.user.company_cd,
                    UserID: this.user.EmployeeCD,
                    Mode: 1,
                    FolderID: '',
                    Keyword: this.data.searchFolder.Keyword,
                    BoxType: this.data.searchFolder.BoxType,
                    MessageType: this.data.searchFolder.MessageType,
                    ActiveFLG: this.data.searchFolder.ActiveFLG
                },
                callback: (data) => {
                    this.setFolder(data);
                }
            });
        },
        onDeleteGroup(item) {
            this.showModalMessage({
                type: MSG_TYPE.CONFIRM,
                title: MSG_TITLE.C003,
                content: messages.C003,
                cancelText: 'いいえ',
                okText: 'はい',
                callback: (ok) => {
                    if (!ok) return;
                    if (this.data.isFolderManagement) {
                        this.deleteFolder({
                            params: {
                                CompanyCD: this.user.company_cd,
                                EmployeeCD: this.user.EmployeeCD,
                                FolderID: item.FolderID
                            },
                            callback: () => {
                                this.showModalMessage({
                                    type: MSG_TYPE.SUCCESS,
                                    title: MSG_TITLE.S002,
                                    content: messages.S002,
                                    okText: MSG_BUTTON.okText,
                                    callback: () => {
                                        this.searchFolder();
                                    }
                                });
                            }
                        });
                        return;
                    }
                    this.deleteGroup({
                        params: {
                            CompanyCD: this.user.company_cd,
                            EmployeeCD: this.user.EmployeeCD,
                            GroupID: item.GroupID
                        },
                        callback: () => {
                            this.showModalMessage({
                                type: MSG_TYPE.SUCCESS,
                                title: MSG_TITLE.S002,
                                content: messages.S002,
                                okText: MSG_BUTTON.okText,
                                callback: () => {
                                    this.searchGroup();
                                }
                            });
                        }
                    });
                }
            });
        },
        changeTypeFolder() {
            this.data.folderDetail.members = [];
            if (this.data.folderDetail.MessageType == 1) {
                this.data.folderDetail.members = [
                    {
                        MDCD: '',
                        MDName: '',
                        ClientCD: '',
                        ClientName: '',
                        BranchCD: '',
                        BranchName: '',
                        UserID: '',
                        UserName: '',
                        LineNo: 1
                    }
                ];
            } else {
                this.data.folderDetail.members = [
                    {
                        EmployeeCD: '',
                        EmployeeName: '',
                        LineNo: 1
                    }
                ];
            }
        },
        openDetail(item) {
            if (this.data.isFolderManagement) {
                this.openFolder(item);
            } else {
                this.openGroup(item);
            }
        },
        openFolder(folder) {
            const showDetail = () => {
                this.setDmMessageMode('groupDetail');
                this.updatePopupConfig({ title: 'フォルダ振り分け設定' });
                this.updatePopupConfig({
                    dimensions: {
                        width: '50%',
                        height: '80%'
                    }
                });
            };
            if (!folder) {
                showDetail();
                this.clearFolderForm();
                this.data.folderDetail.LineNo = this.data.listFolder.length + 1;
            } else {
                this.getFolder({
                    params: {
                        CompanyCD: this.user.company_cd,
                        UserID: this.user.EmployeeCD,
                        Mode: 2,
                        FolderID: folder.FolderID,
                        Keyword: this.data.searchFolder.Keyword,
                        BoxType: this.data.searchFolder.BoxType,
                        MessageType: this.data.searchFolder.MessageType,
                        ActiveFLG: this.data.searchFolder.ActiveFLG
                    },
                    callback: (data) => {
                        this.setFolderDetail(data);
                        showDetail();
                    }
                });
            }
        },
        openGroup(group) {
            const showDetail = () => {
                this.setDmMessageMode('groupDetail');
                this.updatePopupConfig({ title: group ? 'グループ設定（変更）' : 'グループ設定（新規登録）' });
                this.updatePopupConfig({
                    dimensions: {
                        width: '50%',
                        height: '80%'
                    }
                });
            };
            if (!group) {
                showDetail();
                this.clearGroupForm();
                this.data.groupDetail.LineNo = this.data.listGroup.length + 1;
            } else {
                this.getGroup({
                    params: {
                        CompanyCD: this.user.company_cd,
                        UserID: this.user.EmployeeCD,
                        Mode: 2,
                        Keyword: '',
                        GroupID: group.GroupID
                    },
                    callback: (data) => {
                        this.setGroupDetail(data);
                        showDetail();
                    }
                });
            }
        },
        moveUp(index) {
            if (index > 0) {
                const list = this.data.isFolderManagement ? this.data.folderDetail.members : this.data.groupDetail.members;
                const temp = list[index - 1];
                list[index - 1] = list[index];
                list[index] = temp;
                this.updateSortOrder(list);
            }
        },
        moveDown(index) {
            const list = this.data.isFolderManagement ? this.data.folderDetail.members : this.data.groupDetail.members;
            if (index < list.length - 1) {
                const temp = list[index + 1];
                list[index + 1] = list[index];
                list[index] = temp;
                this.updateSortOrder(list);
            }
        },
        updateSortOrder(list) {
            list.forEach((item, index) => {
                item.LineNo = (index + 1).toString();
            });
        },
        addNewMember() {
            const list = this.data.isFolderManagement ? this.data.folderDetail.members : this.data.groupDetail.members;
            if (this.data.isFolderManagement) {
                if (this.data.folderDetail.MessageType == 0) {
                    list.push({
                        EmployeeCD: '',
                        EmployeeName: '',
                        LineNo: ''
                    });
                } else {
                    list.push({
                        MDCD: '',
                        MDName: '',
                        ClientCD: '',
                        ClientName: '',
                        BranchCD: '',
                        BranchName: '',
                        UserID: '',
                        UserName: ''
                    });
                }
            } else {
                list.push({
                    EmployeeCD: '',
                    EmployeeName: '',
                    LineNo: ''
                });
            }
            this.updateSortOrder(list);
        },
        deleteMember(index) {
            const list = this.data.isFolderManagement ? this.data.folderDetail.members : this.data.groupDetail.members;
            list.splice(index, 1);
            this.updateSortOrder(list);
        },

        clearGroupForm() {
            this.data.groupDetail = {
                GroupName: '',
                LineNo: '',
                ShowType: '',
                members: [
                    {
                        EmployeeCD: '',
                        EmployeeName: '',
                        LineNo: ''
                    }
                ]
            };
        },
        clearFolderForm() {
            this.data.folderDetail = {
                FolderName: '',
                LineNo: '',
                BoxType: 0,
                MessageType: 0,
                ActiveFLG: 1,
                members: [
                    {
                        EmployeeCD: '',
                        EmployeeName: '',
                        LineNo: '1'
                    }
                ]
            };
        },
        backListGroup() {
            this.updatePopupConfig({ title: 'グループ設定' });
            this.setDmMessageMode('group');
            this.clearGroupForm();
        },
        backListFolder() {
            this.updatePopupConfig({ title: 'フォルダー一覧' });
            this.setDmMessageMode('group');
            this.clearFolderForm();
        },
        submitGroup() {
            const clearAction = () => {
                if (this.data.isFolderManagement) {
                    this.backListFolder();
                } else {
                    this.backListGroup();
                }
            };
            const clearAfterSumbit = () => {
                this.showModalMessage({
                    type: MSG_TYPE.SUCCESS,
                    title: '報告',
                    content: '送信しました。',
                    okText: 'OK',
                    callback: () => {
                        clearAction();
                    }
                });
            };
            const storeGroup = () => {
                const formData = new FormData();

                formData.append('CompanyCD', this.user.company_cd);
                formData.append('json', JSON.stringify(this.data.groupDetail));

                this.storeGroup({
                    params: formData,
                    callback: () => {
                        clearAfterSumbit();
                    }
                });
            };
            const storeFolder = () => {
                const formData = new FormData();

                formData.append('CompanyCD', this.user.company_cd);
                formData.append('json', JSON.stringify(this.data.folderDetail));

                this.storeFolder({
                    params: formData,
                    callback: () => {
                        clearAfterSumbit();
                    }
                });
            };

            this.showModalMessage({
                type: MSG_TYPE.CONFIRM,
                title: MSG_TITLE.C002,
                content: '送信してもよろしいですか？',
                cancelText: MSG_BUTTON.cancelText,
                okText: MSG_BUTTON.okText,
                callback: (ok) => {
                    if (!ok) return;
                    if (this.data.isFolderManagement) {
                        storeFolder();
                    } else {
                        storeGroup();
                    }
                }
            });
        },
        setListSpanMember() {
            this.listSpanMember = [];
            this.listSpanMember = this.options.groupMember.find((item) => item.GroupID == this.data.group.GroupID)?.member;
        }
    }
};
export default MNG_DM_Message;
</script>
